import React from "react";
import {
  Route,
  Switch,
  withRouter,
  Redirect,
} from "react-router-dom";
import { InspirationConfigurator } from "./pages/InspirationConfigurator";
import { Booths } from "./pages/inspirationEditor/Booths";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Navbar from "./organisms/Navbar";
import { SceneEditorAppWrapper } from "oc-scene-editor/ui/SceneEditorAppWrapper";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { Configurator } from "./pages/Configurator";
import RobotoFont from "./RobotoFont";

function InspirationEditor() {
  const BREAKPOINTS = {
    xs: 0,
    sm: 768,
    md: 960,
    lg: 1280,
    xl: 1920
  };

  const breakpointsFull = {
    breakpoints: createBreakpoints({
      values: BREAKPOINTS
    })
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: `#${APP.metadata.Basis[0].PrimaryColor.getHexString()}`,
      },
      secondary: {
        main: "#3A415A",
      },
      white: {
        main: "#fff",
      },
      danger: {
        main: "#C91113",
      },
      black: {
        main: "#000",
      },
      grey: {
        main: "#939599",
      },
    },
    typography: {
      allVariants: {
        fontFamily: ["Noto Sans TC"].join(","),
      }
    },
    breakpointsFull
  });

  return (
    <>
      <SceneEditorAppWrapper position="right" sceneNode={APP.sceneNode} isAdmin={APP.settings.userRole == "admin"}>
        <RobotoFont />
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Switch>
            <Route exact path="/">
              <Navbar />
              <Redirect to="/booths" />
            </Route>
            <Route path="/booths">
              <Navbar />
              <Booths />
            </Route>
            <Route path="/:boothId/configurator">
              <Navbar />
              <InspirationConfigurator />
            </Route>
          </Switch>
        </ThemeProvider>
      </SceneEditorAppWrapper>
    </>
  );
}

export default withRouter(InspirationEditor);
